import cx from 'classnames';
import {Button} from '../../../../../atoms/Button';
import {ArrowIcon} from '../../../../../svg/ArrowIcon';
import {CloseLineIcon} from '../../../../../svg/CloseLineIcon';

import './DrawerHeader.sass';

export const DrawerHeader = ({showBackArrow, onGoBack, onClose}) => (
  <div className="category-drawer__header">
    <Button
      variant="unstyled-button"
      onClick={onGoBack}
      data-qa-id="back-to-categories"
      className={cx('category-drawer__header__back-button', {
        'category-drawer__header__back-button--hidden': !showBackArrow,
      })}
    >
      <ArrowIcon direction="left" ratio={0.75} />
    </Button>
    <Button variant="unstyled-button" onClick={onClose} data-qa-id="close-category-drawer">
      <CloseLineIcon ratio={0.75} />
    </Button>
  </div>
);
